import { render, staticRenderFns } from "./TTLabel.vue?vue&type=template&id=e37d8996&scoped=true"
import script from "./TTLabel.vue?vue&type=script&lang=js"
export * from "./TTLabel.vue?vue&type=script&lang=js"
import style0 from "./TTLabel.vue?vue&type=style&index=0&id=e37d8996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37d8996",
  null
  
)

export default component.exports